import { apiUrl } from '../utils/constants';
import { DELETE, GET, POST, PUT } from './api.service.wrapper';



export const GetTraining = async (keyword = '', page = '', perPage = '', is_paginate = 1, status = null) => {
    let params = {};

    if (page) {
        params['page'] = page;
    }

    if (perPage) {
        params['per_page'] = perPage;
    }


    if (keyword) {
        params['title'] = keyword;
    }

    if (status) {
        params['status'] = status;
    }
    if(is_paginate === 1){
        params['paginate'] = is_paginate;
    }


    const response = await GET(apiUrl.training, params);
    return response;
}

export const GetStepsCompleted = async (keyword = '', page = '', perPage = '', is_paginate = 1,user=null) => {
    let params = {};

    if (page) {
        params['page'] = page;
    }

    if (perPage) {
        params['per_page'] = perPage;
    }


    if (keyword) {
        params['title'] = keyword;
    }


    if (user) {
        params['user_id'] = user;
    }

    if(is_paginate==1){
        params['paginate'] = is_paginate;
    }

    const response = await GET(apiUrl.training_step_completed, params);
    return response;
}

export const GetTrainingById = async (id) => {
    let params = {};
    let response = '';
    response = await GET(apiUrl.training + '/' + id,params);
    return response;
}

export const CreateTraining = async (data) => {
    const response = await POST(apiUrl.training, data);
    return response;
}

export const UpdateTraining = async (id, data) => {
    const response = await PUT(apiUrl.training, id, data);
    return response;
}

export const DeleteTraining = async (id) => {
    const response = await DELETE(apiUrl.training, id);
    return response;
}
